import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../AuthContext';
import CoachSidebar from '../components/CoachSidebar';

function formatarData(valor) {
  if (!valor) return '—';

  try {
    return new Intl.DateTimeFormat('pt-BR', {
      dateStyle: 'short',
      timeStyle: 'short'
    }).format(new Date(valor));
  } catch {
    return '—';
  }
}

export default function CoachParticipantes() {
  const { user, logout } = useAuth();
  const navigate = useNavigate();

  const [participantes, setParticipantes] = useState([]);
  const [loading, setLoading] = useState(true);
  const [erro, setErro] = useState('');

  useEffect(() => {
    let ativo = true;

    async function carregarParticipantes() {
      try {
        setErro('');

        const response = await fetch('/api/coach/participantes', {
          method: 'GET',
          credentials: 'include'
        });

        const data = await response.json().catch(() => ({}));

        if (!response.ok || !data.ok) {
          throw new Error(
            data.error || 'Não foi possível carregar os Participantes.'
          );
        }

        if (ativo) {
          setParticipantes(data.participantes || []);
        }
      } catch (e) {
        if (ativo) {
          setErro(
            e.message || 'Não foi possível carregar os Participantes.'
          );
        }
      } finally {
        if (ativo) {
          setLoading(false);
        }
      }
    }

    carregarParticipantes();

    return () => {
      ativo = false;
    };
  }, []);

  async function sair() {
    await logout();
    window.location.href = '/login';
  }

  return (
    <>
      <CoachSidebar />
      <main
      style={{
        minHeight: '100vh',
        background: '#f4f4f4',
        padding: '2.5rem 1.5rem',
        boxSizing: 'border-box',
        marginLeft: 220
      }}
    >
      <div
        style={{
          maxWidth: 1180,
          margin: '0 auto'
        }}
      >
        <div
          style={{
            display: 'flex',
            justifyContent: 'space-between',
            alignItems: 'flex-start',
            gap: 20,
            flexWrap: 'wrap',
            marginBottom: 28
          }}
        >
          <div>
            <h1
              style={{
                margin: 0,
                color: '#242F3C',
                fontSize: '2rem'
              }}
            >
              Meus Participantes
            </h1>

            <p
              style={{
                color: '#697382',
                marginTop: 8,
                marginBottom: 0
              }}
            >
              Consulte os Participantes vinculados ao seu acompanhamento e acesse suas avaliações.
            </p>

            <div
              style={{
                marginTop: 8,
                color: '#98A2B3',
                fontSize: '0.92rem'
              }}
            >
              {user?.nome || user?.email || 'Coach'}
            </div>
          </div>

          <button
            type="button"
            onClick={sair}
            style={{
              background: '#242F3C',
              color: '#fff',
              border: 'none',
              borderRadius: 8,
              padding: '10px 18px',
              fontWeight: 700,
              cursor: 'pointer'
            }}
          >
            Sair
          </button>
        </div>

        {erro && (
          <div
            role="alert"
            style={{
              marginBottom: 20,
              padding: '12px 14px',
              borderRadius: 8,
              background: '#FFF3F2',
              color: '#B42318',
              border: '1px solid #FECDCA',
              fontWeight: 600
            }}
          >
            {erro}
          </div>
        )}

        <section
          style={{
            background: '#fff',
            borderRadius: 12,
            boxShadow: '0 2px 10px rgba(36,47,60,0.06)',
            overflowX: 'auto'
          }}
        >
          <div
            style={{
              padding: '1.5rem',
              borderBottom: '1px solid #EEF0F2'
            }}
          >
            <h2
              style={{
                margin: 0,
                color: '#242F3C',
                fontSize: '1.25rem'
              }}
            >
              Meus Participantes
            </h2>

            <div
              style={{
                color: '#697382',
                marginTop: 6,
                fontSize: '0.92rem'
              }}
            >
              {loading
                ? 'Carregando...'
                : `${participantes.length} Participante${participantes.length === 1 ? '' : 's'} vinculado${participantes.length === 1 ? '' : 's'}`}
            </div>
          </div>

          <table
            style={{
              width: '100%',
              borderCollapse: 'collapse',
              minWidth: 980
            }}
          >
            <thead style={{ background: '#f7f7f7' }}>
              <tr>
                <th style={th}>Participante</th>
                <th style={th}>Empresa</th>
                <th style={th}>Cargo</th>
                <th style={th}>Status</th>
                <th style={th}>Avaliações</th>
                <th style={th}>Última avaliação</th>
              </tr>
            </thead>

            <tbody>
              {loading ? (
                <tr>
                  <td
                    colSpan="6"
                    style={{
                      padding: '2rem',
                      textAlign: 'center',
                      color: '#697382'
                    }}
                  >
                    Carregando Participantes...
                  </td>
                </tr>
              ) : (
                participantes.map(participante => (
                  <tr
                    key={participante.participant_id}
                    onClick={() => navigate(`/coach/participantes/${encodeURIComponent(participante.participant_id)}`)}
                    style={{ cursor: 'pointer' }}
                  >
                    <td style={td}>
                      <div
                        style={{
                          fontWeight: 700,
                          color: '#242F3C'
                        }}
                      >
                        {participante.nome || '—'}
                      </div>

                      <div
                        style={{
                          marginTop: 4,
                          color: '#697382',
                          fontSize: '0.88rem'
                        }}
                      >
                        {participante.email || '—'}
                      </div>
                    </td>

                    <td style={td}>
                      {participante.empresa || '—'}
                    </td>

                    <td style={td}>
                      {participante.cargo || '—'}
                    </td>

                    <td style={td}>
                      <span
                        style={{
                          display: 'inline-block',
                          padding: '6px 10px',
                          borderRadius: 999,
                          fontWeight: 700,
                          fontSize: '0.84rem',
                          background:
                            participante.status_acesso === 'active'
                              ? '#E8F6ED'
                              : '#EDF1F5',
                          color:
                            participante.status_acesso === 'active'
                              ? '#246B3C'
                              : '#697382'
                        }}
                      >
                        {participante.status_acesso === 'active'
                          ? 'Ativo'
                          : participante.status_acesso
                            ? 'Sem acesso ativo'
                            : 'Sem conta'}
                      </span>
                    </td>

                    <td style={td}>
                      {Number(participante.total_avaliacoes || 0)}
                    </td>

                    <td style={td}>
                      {formatarData(participante.ultima_avaliacao)}
                    </td>
                  </tr>
                ))
              )}

              {!loading && participantes.length === 0 && (
                <tr>
                  <td
                    colSpan="6"
                    style={{
                      padding: '2.5rem',
                      textAlign: 'center',
                      color: '#697382'
                    }}
                  >
                    Nenhum Participante está vinculado ao seu acesso.
                  </td>
                </tr>
              )}
            </tbody>
          </table>
        </section>
      </div>
      </main>
    </>
  );
}

const th = {
  padding: 14,
  borderBottom: '2px solid #e6e6e6',
  textAlign: 'left',
  color: '#242F3C',
  whiteSpace: 'nowrap'
};

const td = {
  padding: 14,
  borderBottom: '1px solid #eef0f2',
  verticalAlign: 'middle'
};




